import { Vector2 } from 'three';

const Input = {
  pointer_count: 0,
  left_mouse_button_pressed: false,
  left_mouse_button_down: false,
  right_mouse_button_pressed: false,
  right_mouse_button_down: false,
  scroll_delta: 0,
  NDC: new Vector2(),
  NDC_delta: new Vector2(),

  _prevNDC: new Vector2(),
  _lmbJustDown: false,
  _rmbJustDown: false,
  _scrollAccum: 0,
  _canvas: null,
  _initialized: false,

  _init(canvas) {
    if (this._initialized) return;
    this._initialized = true;
    this._canvas = canvas;

    const updateNDC = (x, y) => {
      const rect = canvas.getBoundingClientRect();
      this.NDC.x = ((x - rect.left) / rect.width) * 2 - 1;
      this.NDC.y = -((y - rect.top) / rect.height) * 2 + 1;
    };

    canvas.addEventListener('mousedown', e => {
      if (e.button === 0) { this.left_mouse_button_down = true; this._lmbJustDown = true; }
      if (e.button === 2) { this.right_mouse_button_down = true; this._rmbJustDown = true; }
    });

    canvas.addEventListener('mouseup', e => {
      if (e.button === 0) this.left_mouse_button_down = false;
      if (e.button === 2) this.right_mouse_button_down = false;
    });

    canvas.addEventListener('mousemove', e => updateNDC(e.clientX, e.clientY));

    canvas.addEventListener('wheel', e => {
      this._scrollAccum += e.deltaY > 0 ? 1 : e.deltaY < 0 ? -1 : 0;
    }, { passive: true });

    canvas.addEventListener('touchstart', e => {
      this.pointer_count = e.touches.length;
      if (e.touches.length > 0) {
        updateNDC(e.touches[0].clientX, e.touches[0].clientY);
        this.left_mouse_button_down = true;
        this._lmbJustDown = true;
      }
    }, { passive: true });

    canvas.addEventListener('touchmove', e => {
      this.pointer_count = e.touches.length;
      if (e.touches.length > 0) {
        updateNDC(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });

    canvas.addEventListener('touchend', e => {
      this.pointer_count = e.touches.length;
      if (e.touches.length === 0) {
        this.left_mouse_button_down = false;
      }
    }, { passive: true });

    canvas.addEventListener('contextmenu', e => e.preventDefault());
  },

  update() {
    this.NDC_delta.set(this.NDC.x - this._prevNDC.x, this.NDC.y - this._prevNDC.y);
    this._prevNDC.copy(this.NDC);

    this.left_mouse_button_pressed = this._lmbJustDown;
    this.right_mouse_button_pressed = this._rmbJustDown;
    this._lmbJustDown = false;
    this._rmbJustDown = false;

    this.scroll_delta = this._scrollAccum;
    this._scrollAccum = 0;
  },
};

export { Input };
